import React from 'react';
import LocationPic from "./LocationPic.jpg";
import { MailPlus, MapPin, Phone } from 'lucide-react';

function Contact() {
    return (
        <section>
            <div className="relative">
                <img
                    className="h-96 w-full object-cover object-center rounded-b-2xl shadow-2xl"
                    src={LocationPic}
                    alt="A beautiful landscape"
                    loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-b-2xl"></div>
                <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-10 flex flex-col items-center w-full px-4">
                    <h1
                        className="text-4xl md:text-5xl font-extrabold text-white mb-3 text-center tracking-tight shadow-sm"
                    >
                        Get in Touch
                    </h1>
                </div>
            </div>

            <div className=''>
                <div className='py-12 container mx-auto text-center px-4'>
                    <h3 className="font-bold">Reach out through any of the contacts <br /> or visit the offices physically.</h3>

                    <div className='flex gap-2 justify-center items-center mt-5'>
                        <Phone className='w-8 h-8 text-[#ebcab3]' />
                        <b>Call Us:</b>
                        +254 799 093 219
                    </div>

                    <div className='flex gap-2 justify-center items-center'>
                        <MailPlus className='w-8 h-8  text-[#ebcab3]' />
                        <b>Email Us:</b>
                        info@lsb.go.ke
                    </div>

                    <div className='flex gap-2 justify-center items-center'>
                        <MapPin className='w-8 h-8  text-[#ebcab3]' />
                        <b>Visit Us:</b>
                        Land Surveyors’ Board, Survey of Kenya Headqurters
                    </div>
                </div>

                <iframe
                    title="Google Maps"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3298.0888817730593!2d36.855417073991916!3d-1.2494396355849173!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f1687d0000001%3A0x60dca9458a33a718!2sSurvey%20Of%20Kenya!5e1!3m2!1sen!2ske!4v1706396670538!5m2!1sen!2ske"
                    width="100%"
                    height="700px"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    className=""
                />
            </div>
        </section>
    )
}

export default Contact;
